// extracted by mini-css-extract-plugin
export var active = "_4m-7";
export var container = "_4m-0";
export var evenWidth = "_4m-4";
export var large = "_4m-5";
export var outlet = "_4m-8";
export var slide = "_4m-2";
export var small = "_4m-6";
export var tab = "_4m-3";
export var tabs = "_4m-1";